export const misDatos = {
    nombre: "Marina Mateo Lara",
    profesion: "Frontend Developer",
    linkedin: "https://www.linkedin.com/in/marina-mateo-lara-1b2213284/",
    github: "https://github.com/Marinamlittle",
    netlify: "https://app.netlify.com/teams/mmldev23/projects"
  };